import ShoppingLists from '@/pages/ShoppingLists'
export default {
    path: '',
    component: ShoppingLists,
    children: [
        {
            path: '/shopping/lists',
            name: 'Shopping Lists',
            component: ShoppingLists,
        },
        {
            path: '/shopping/lists/new',
            name: 'New Shopping List',
            component: ShoppingLists,
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/shoppinglists.js